import React from 'react';
import Chip from 'Chip';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng/ui_pc_ad';
import UserInfo from '@ifeng/ui_pc_userInfo';
import Search from '@ifeng/ui_pc_search';
import errorBoundary from '@ifeng/errorBoundary';
import Logo from './logo/';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const { search, topAd, sectionTitle, logo, sectionUrl } = content;
        const logoData = { sectionTitle, logo, sectionUrl };

        return (
            <div>
                <div className={styles.topAd_box}>
                    <Ad content={topAd} styleName={styles.topAd} />
                </div>
                <div className={styles.header}>
                    <div className={styles.header_bar}>
                        <Logo content={logoData} />
                        <div className={styles.box}>
                            <div className={styles.search}>
                                <Chip
                                    id="10129"
                                    type="static"
                                    title="搜索"
                                    groupName="头部"
                                    translate="jsonParse"
                                    content={search}>
                                    <Search expand />
                                </Chip>
                            </div>
                            <div className={styles.user}>
                                <UserInfo iconShow option={['login']} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Header);
